import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { ModulePermissionGuard } from '@core/guards/module-perission.guard';
import { ModulesComponent } from './modules.component';

const routes: Routes = [
  {
    path: '',
    component: ModulesComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard-routing.module').then(
            (m) => m.DashboardRoutingModule,
          ),
      },
      {
        path: 'participants',
        loadChildren: () =>
          import('./participants/participants-routing.module').then(
            (m) => m.ParticipantsRoutingModule,
          ),
        canActivateChild: [ModulePermissionGuard],
      },
      {
        path: 'lines',
        loadChildren: () =>
          import('./lines-groups/lines-groups-routing.module').then(
            (m) => m.LinesGroupsRoutingModule,
          ),
        canActivateChild: [ModulePermissionGuard],
      },
      {
        path: 'programs',
        loadChildren: () =>
          import('./programs/programs-routing.module').then(
            (m) => m.ProgramsRoutingModule,
          ),
        canActivateChild: [ModulePermissionGuard],
      },
      {
        path: 'configurations',
        loadChildren: () =>
          import('./configurations/configurations-routing.module').then(
            (m) => m.ConfigurationsRoutingModule,
          ),
        canActivateChild: [ModulePermissionGuard],
      },
      {
        path: 'invoices',
        loadChildren: () =>
          import('./invoices/invoices-routing.module').then(
            (m) => m.InvoicesRoutingModule,
          ),
      },
      {
        path: 'catalogs',
        loadChildren: () =>
          import('./catalogs/catalogs-routing.module').then(
            (m) => m.CatalogsRoutingModule,
          ),
      },
      {
        path: 'flows-history',
        loadChildren: () =>
          import('./flows-history/flows-history-routing.module').then(
            (m) => m.FlowsHistoryRoutingModule,
          ),
      },
      {
        path: 'flow-tools',
        loadChildren: () =>
          import('./flow-tools/flow-tools-routing.module').then(
            (m) => m.FlowToolsRoutingModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModulesRoutingModule {}
